import { types } from './pbindicador.actions'
import { Reducer } from '../../../services/reducer.factory'

// PHOENIX-794 -- Esse form foi criado especificamente para o indicador de Bom Pastor
const initialState = {
  id: 'pbindicador',
  columns: [],
  currentRecord: {
    oid: '',
    nome: '',
    cpf: '',
    telefone: '',
    email: '',
    tipoChavePix: '',
    chavePix: '',
    unidade: '',
  },
  messages: null,
  usaListDto: false,
}

const reducer = new Reducer(initialState, types)

export function CRUDPbIndicadorReducer(state, action) {
  if (state) {
    state.messages = {}
  }
  state = reducer.execute(state, action)
  return execute(state, action)
}

function execute(state, action) {
  let result = state
  switch (action.type) {
    case types.RESET_FORM:
      return resetForm(state, action)
    default:
      return result
  }
}

function resetForm(state, action) {
  let booleanFilter = Object.assign({}, state.booleanFilter)
  booleanFilter[action.field] = action.value
  return Object.assign({}, state, { currentRecord: initialState.currentRecord })
}
